import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "../authServices";

@Component({
  selector: "vex-session-expired-dialog",
  templateUrl: "./session-expired-dialog.component.html",
  styleUrls: ["./session-expired-dialog.component.scss"],
})
export class SessionExpiredDialogComponent {
  readonly message =
    "Your session was inactive for more than 1 hour and has expired. Please sign in again to continue using the application.";

  constructor(
    private dialogRef: MatDialogRef<SessionExpiredDialogComponent>,
    private authService: AuthService,
    private router: Router
  ) {}

  onSignIn(): void {
    this.authService.clearSessionExpiredState();
    this.authService.clearAuthDataForSignInAfterExpiry();
    this.dialogRef.close(true);
    this.router.navigate(["/login"]);
  }
}
